var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEntrance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 23,
    viewBox: "0 0 19 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1127_3608)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7883 0.847656H6.83571C5.61928 0.847656 4.62402 1.84291 4.62402 3.05934V4.16518C4.62402 4.45847 4.74053 4.73975 4.94792 4.94713C5.1553 5.15452 5.43658 5.27103 5.72987 5.27103C6.02315 5.27103 6.30443 5.15452 6.51182 4.94713C6.7192 4.73975 6.83571 4.45847 6.83571 4.16518V3.05934H16.7883V20.7528H6.83571V19.647C6.83571 19.3537 6.7192 19.0724 6.51182 18.865C6.30443 18.6576 6.02315 18.5411 5.72987 18.5411C5.43658 18.5411 5.1553 18.6576 4.94792 18.865C4.74053 19.0724 4.62402 19.3537 4.62402 19.647V20.7528C4.62402 21.9693 5.61928 22.9645 6.83571 22.9645H16.7883C18.0047 22.9645 19 21.9693 19 20.7528V3.05934C19 1.84291 18.0047 0.847656 16.7883 0.847656ZM10.1793 16.6554C9.748 17.0867 9.05132 17.0867 8.62004 16.6554C8.41333 16.4485 8.29712 16.168 8.29692 15.8755C8.29671 15.583 8.41251 15.3023 8.61894 15.0951L10.6935 13.0117H1.10584C0.812555 13.0117 0.53128 12.8952 0.323894 12.6878C0.116508 12.4804 0 12.1991 0 11.9058C0 11.6126 0.116508 11.3313 0.323894 11.1239C0.53128 10.9165 0.812555 10.8 1.10584 10.8H10.6935L8.61894 8.71659C8.42895 8.50638 8.32699 8.23121 8.33414 7.94795C8.34129 7.6647 8.457 7.39502 8.65736 7.19466C8.85771 6.99431 9.12739 6.8786 9.41065 6.87145C9.6939 6.8643 9.96907 6.96625 10.1793 7.15625L14.147 11.124C14.3544 11.3314 14.4708 11.6126 14.4708 11.9058C14.4708 12.1991 14.3544 12.4803 14.147 12.6877L10.1793 16.6554Z",
    fill: "#F89500"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1127_3608",
    x: 0,
    y: 0.847656,
    width: 19.3333,
    height: 22.45,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.333328,
    dy: 0.333328
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.666656
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.19534 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1127_3608"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntrance);
export default __webpack_public_path__ + "static/media/entrance.603459486c266b42568ba163083a1541.svg";
export { ForwardRef as ReactComponent };